import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const ReportFilters = ({ filters, onFilterChange, onReset, reportType }) => {
  const positionOptions = [
    { value: 'all', label: 'All Positions' },
    { value: 'forward', label: 'Forward' },
    { value: 'midfielder', label: 'Midfielder' },
    { value: 'defender', label: 'Defender' },
    { value: 'winger', label: 'Winger' },
    { value: 'striker', label: 'Striker' },
    { value: 'attacking-midfielder', label: 'Attacking Midfielder' },
    { value: 'defensive-midfielder', label: 'Defensive Midfielder' },
    { value: 'center-back', label: 'Center Back' },
    { value: 'full-back', label: 'Full Back' }
  ];

  const leagueOptions = [
    { value: 'all', label: 'All Leagues/Teams' },
    { value: 'premier-league', label: 'Premier League' },
    { value: 'la-liga', label: 'La Liga' },
    { value: 'bundesliga', label: 'Bundesliga' },
    { value: 'serie-a', label: 'Serie A' },
    { value: 'ligue-1', label: 'Ligue 1' },
    { value: 'eredivisie', label: 'Eredivisie' },
    { value: 'primeira-liga', label: 'Primeira Liga' }
  ];

  const timeframeOptions = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '3months', label: 'Last 3 Months' },
    { value: '6months', label: 'Last 6 Months' },
    { value: '1year', label: 'Last Year' },
    { value: 'all', label: 'All Time' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-foreground">Filters</h3>
        <Button variant="ghost" size="sm" onClick={onReset} iconName="RotateCcw" iconPosition="left">
          Reset
        </Button>
      </div>
      <div className="space-y-4">
        {(reportType === 'players' || reportType === 'goalkeepers') && (
          <Select
            label="Position"
            options={positionOptions}
            value={filters?.position}
            onChange={(value) => onFilterChange('position', value)}
          />
        )}

        <Select
          label="League/Team"
          options={leagueOptions}
          value={filters?.league}
          onChange={(value) => onFilterChange('league', value)}
          description="Filter by league or team name"
        />

        <Select
          label="Timeframe"
          options={timeframeOptions}
          value={filters?.timeframe}
          onChange={(value) => onFilterChange('timeframe', value)}
          description="Filter by record creation date"
        />
      </div>
    </div>
  );
};

export default ReportFilters;